export default {
  message: {
    customerNumbersAssistant: {
      date: {
        title: 'Calcola i punti dalla data X',
        warning:
          'Con una data selezionata, i numeri cliente principali non possono essere spostati!',
      },
      import: {
        openButton: 'Importa numeri cliente',
        loadingModal: 'Caricamento finestra...',
        title: 'Importa numeri cliente da Excel',
        validateButton: 'Valida file',
        submitButton: "Invia all'API",
        submitButtonLoading: 'Invio in corso...',
        selectWholesalerLabel: 'Grossista',
        selectGroupLabel: 'Gruppo',
        selectWholesalerPlaceholder: 'Seleziona grossista',
        selectGroupPlaceholder: 'Seleziona gruppo (opzionale)',
        requirementsTitle: 'Requisiti del file',
        fileFormatRequirement: 'Solo file Excel: .xlsx o .xls',
        headerRequirement:
          'La riga di intestazione deve essere: Customer number, Email (colonne A/B).',
        createdLabel: 'Creati',
        alreadyExistsLabel: 'Già esistenti',
        success: 'Il file Excel è valido.',
        submitSuccess: 'I numeri cliente sono stati importati con successo.',
        previewTitle: 'Anteprima',
        summaryTitle: 'Riepilogo validazione',
        previewCount: '{count} righe, {pageSize} righe per pagina.',
        importableCountLabel: 'Importabili',
        skippedCountLabel: 'Verranno saltati',
        searchPlaceholder: 'Cerca per riga, numero cliente, email o stato',
        confirmImportTitle: 'Conferma importazione',
        confirmImportQuestion: 'Vuoi importare ora i record disponibili?',
        confirmImportButton: 'Importa ora',
        filters: {
          all: 'Tutti',
          importable: 'Importabili',
          skipped: 'Saltati',
        },
        row: 'Riga',
        customerNumber: 'Numero cliente',
        email: 'Email',
        status: 'Stato',
        userExists: "L'utente esiste",
        customerNumberExists: 'Il numero cliente esiste',
        customerNumberExistsForEmail: "Il numero cliente esiste per l'email",
        customerNumberOwnerEmail: 'Email proprietario numero cliente',
        conflictsFound: "Sono stati trovati conflitti. Correggili prima dell'import.",
        previousPage: 'Precedente',
        nextPage: 'Successiva',
        pageInfo: 'Pagina {current} / {total}',
        progressLabel: 'Avanzamento',
        statusLabels: {
          available_for_import: "Disponibile per l'import",
          already_linked: 'Già collegato',
          customer_number_linked_to_other_user: 'Numero cliente collegato a un altro utente',
          user_not_found: 'Utente non trovato',
          user_not_dealer: "L'utente non è dealer",
          user_in_other_group: "L'utente è in un altro gruppo",
        },
        summaryLabels: {
          total_rows: 'Righe totali',
          available_for_import: "Disponibile per l'import",
          already_linked: 'Già collegato',
          customer_number_linked_to_other_user: 'Collegato a un altro utente',
          user_not_found: 'Utente non trovato',
          user_not_dealer: "L'utente non è dealer",
          user_in_other_group: 'Utente in un altro gruppo',
        },
        errors: {
          wholesalerRequired: 'Il grossista è obbligatorio.',
          groupRequired: 'Il gruppo è obbligatorio.',
          fileRequired: 'Il file Excel è obbligatorio.',
          emptyWorkbook: 'La cartella di lavoro Excel è vuota.',
          invalidHeaders:
            'Il file deve contenere esattamente 2 colonne: numero cliente ed email.',
          emptyRows: 'Il file non contiene righe di dati.',
          firstTwoColumnsRequired:
            'Riga {row}: la prima e la seconda colonna devono essere compilate.',
          invalidCustomerNumber:
            'Numero cliente non valido alla riga {row}. Usa solo lettere e cifre.',
          invalidEmail: 'Email non valida alla riga {row}.',
          invalidFileType: 'Sono consentiti solo file Excel (.xlsx, .xls).',
          readError: 'Impossibile leggere il file Excel.',
          validateFirst: 'Valida prima il file.',
          conflictsBeforeImport: "L'import è bloccato a causa di conflitti di validazione.",
          nothingToImport: "Non ci sono record disponibili per l'import.",
          submitFailed: "Invio dei record all'API non riuscito.",
        },
      },
    },
  },
}
